import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';

interface MailChimpResponse {
  result: 'success' | 'error';
  msg: string;
}

@Injectable({
  providedIn: 'root',
})
export class MailChimpService {

  constructor(private _http: HttpClient) {}

  submitMailchimpForm(data: {[key: string]: string}, url: string): Observable<{success: boolean, error?: string}> {
    let params = new HttpParams().set('url', url);
    Object.keys(data).forEach(key=>{
      params = params.set(key, data[key]);
    });

    return this._http.post<MailChimpResponse>(`/submit-mailchimp-form`, {}, {
      params,
    })
      .pipe(map(response => {
        if (response.result && response.result !== 'error') {
          return {
            success: true
          }
        }
        else {
          return {
            success: false,
            error: response.msg
          }
        }
      }));
}
}
